import { KioskIntegration } from '@inter-ikea-gallery/integration';
import { isIkeaApp, isKiosk } from './platform';
import { getQuery } from './queryUtils';
import { useEffect } from 'react';

export const isSpaceEnabled = () => getQuery().get('enableSpacePlanning') === 'true';

export const isGalleryActive = () => isKiosk() && getQuery().get('ipexGallery') === 'true';

export const isUpptackaActive = () => isKiosk() && getQuery().get('origin') === 'upptacka';

export const anyIntegrationActive = () => isKiosk() && (isUpptackaActive() || isGalleryActive());

export const getKioskIntegration = () => new KioskIntegration();

export const appIntegration = {
  summaryClicked: (vpcCode: string) => isIkeaApp() && alert('Summary clicked ' + vpcCode),
  backClicked: () => isIkeaApp() && alert('Back clicked')
};

export const useIntegrationInteraction = () => {
  useEffect(() => {
    const kioskIntegration = getKioskIntegration();

    const onInteraction = () => {
      kioskIntegration.userInteraction();
    };

    document.addEventListener('keypress', onInteraction, true);
    document.addEventListener('mousedown', onInteraction, true);
    document.addEventListener('touchstart', onInteraction, true);

    return () => {
      document.removeEventListener('keypress', onInteraction, true);
      document.removeEventListener('mousedown', onInteraction, true);
      document.removeEventListener('touchstart', onInteraction, true);
    };
  }, []);
};
